<template>
    <div>
        <div class="apprentice-simple-card remove-bottom-card-margin source-lists">
            <div class="intro-text">
                <h3 class="title">{{ title }}</h3>
                <p class="muted-text">{{ $t('project.make_easily_your_source_list_in_apa_style') }}</p>
                <b-alert
                    v-if="editMode"
                    show
                    variant="warning">
                    {{ $t('project.you_are_going_to_edit_a_source') }}
                </b-alert>
            </div>

            <b-tabs
                class="apprentice-tab source-list-tab"
                v-model="activeTab"
                content-class="source-list-tab-content"
                nav-wrapper-class="source-list-tab-wrapper"
                @input="updateTabIndex">
                <b-tab
                    :title="$t('project.internet_source')"
                    title-item-class="source-list-tab-item"
                    title-link-class="source-list-tab-item-link">
                    <design-2021-source-internet-form :project-id="projectId"></design-2021-source-internet-form>
                </b-tab>

                <b-tab
                    :title="$t('project.book')"
                    title-item-class="source-list-tab-item"
                    title-link-class="source-list-tab-item-link">
                    <design-2021-source-book-form :project-id="projectId"></design-2021-source-book-form>
                </b-tab>

                <b-tab
                    title="Journal"
                    title-item-class="source-list-tab-item"
                    title-link-class="source-list-tab-item-link">
                    <design-2021-source-journal-form :project-id="projectId"></design-2021-source-journal-form>
                </b-tab>

                <b-tab
                    :title="$t('project.newspaper_magazine')"
                    title-item-class="source-list-tab-item"
                    title-link-class="source-list-tab-item-link">
                    <design-2021-source-paper-form :project-id="projectId"></design-2021-source-paper-form>
                </b-tab>

                <b-tab
                    :title="$t('project.report')"
                    title-item-class="source-list-tab-item"
                    title-link-class="source-list-tab-item-link">
                    <design-2021-source-rapport-form :project-id="projectId"></design-2021-source-rapport-form>
                </b-tab>

                <b-tab
                    title="Interview"
                    title-item-class="source-list-tab-item"
                    title-link-class="source-list-tab-item-link">
                    <design-2021-source-interview-form :project-id="projectId"></design-2021-source-interview-form>
                </b-tab>
            </b-tabs>
        </div>

        <design-2021-source-list-table-component
            :project-id="projectId"
            :source-list-data-in="sourceListDataIn"
            @show-tab="showTab">
        </design-2021-source-list-table-component>
    </div>
</template>

<script>
import { SourceBus } from '../../../app';

export default {
    name: 'design-2021-project-show-source-component',
    props: ['projectId', 'sourceListDataIn'],
    data() {
        return {
            activeTab: 0,
            title: 'APA Generator',
            editMode: false,
        };
    },

    methods: {
        updateTabIndex(tabIndex) {
            this.activeTab = tabIndex;
            localStorage.sourceListSettingsTab = tabIndex;
        },

        showTab(tabIndex) {
            this.activeTab = tabIndex;
        },
    },

    mounted() {
        if (localStorage.sourceListSettingsTab) {
            this.activeTab = parseInt(localStorage.sourceListSettingsTab);
        }
    },

    created() {
        SourceBus.$on('updateTabs', (data) => {
            this.editMode = true;

            if (data === 'Internet') {
                this.tabIndex = 0;
                this.title = `APA Generator: ${this.$t('project.edit_internet_source')}`;
            }

            if (data === 'Book') {
                this.tabIndex = 1;
                this.title = `APA Generator: ${this.$t('project.edit_book')}`;
            }

            if (data === 'Journal') {
                this.tabIndex = 2;
                this.title = `APA Generator: ${this.$t('project.edit_journal')}`;
            }

            if (data === 'Paper') {
                this.tabIndex = 3;
                this.title = `APA Generator: ${this.$t('project.edit_newspaper_magazine')}`;
            }

            if (data === this.$t('project.report')) {
                this.tabIndex = 4;
                this.title = `APA Generator: ${this.$t('project.edit_report')}`;
            }
        });

        SourceBus.$on('resetEditMode', () => {
            this.editMode = false;
            this.title = 'APA Generator';
        });
    },
};
</script>

<style scoped lang="scss">
@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .source-lists {
        .source-list-tab {
            .tab-content {
                height: auto;
            }
        }
    }
}
</style>
